import { ReactNode } from 'react'
import { useAuth } from './AuthProvider'
import { Loading } from '../../components/common'
import OfflineCapture from '../../pages/captures/OfflineCapture/OfflineCapture'
import { AUTH_OFFLINE_ERROR_MSG } from '../../shared/constants/global'
import ErrorCapture from '../../pages/captures/ErrorCapture/ErrorCapture'
import { Typography } from '@mui/material'

interface AuthGateProps {
  children: ReactNode
}

const AuthGate = (props: AuthGateProps) => {
  const { children } = props
  const { loading, error, isOffline } = useAuth()

  if (loading) {
    return <Loading fullscreen loading={true} message="Authenticating..." />
  }

  if (isOffline) {
    return <OfflineCapture />
  }

  if (error) {
    console.error('Auth error:', error)
    const renderableError =
      error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : null
    if (renderableError === AUTH_OFFLINE_ERROR_MSG) {
      return <OfflineCapture />
    }
    return (
      <ErrorCapture title="Auth Error">
        {renderableError ? (
          <Typography>{renderableError}</Typography>
        ) : (
          <Typography>Check console for details.</Typography>
        )}
      </ErrorCapture>
    )
  }

  return <>{children}</>
}

export default AuthGate
